import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "teinte-details"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Nom du film : ", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Fournisseur : ", -1)
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Groupe de prix : ", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Garantie France : ", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Type de film : ", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Nuance : ", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Collection : ", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Structure : ", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Référence d'usage : ", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Référence utilisée : ", -1)
const _hoisted_22 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dig_ui_icon = _resolveComponent("dig-ui-icon")!

  return (_ctx.teinte)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_dig_ui_icon, {
          class: "icon",
          type: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }),
        _createElementVNode("img", {
          src: _ctx.getImgUrl('teintes/' + _ctx.teinte.image)
        }, null, 8, _hoisted_2),
        _createElementVNode("div", null, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.teinte.nomDuFilm), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.teinte.fournisseur), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.teinte.groupePrixCoprodex), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.teinte.garantieFrance), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.teinte.typeDeFilm), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.teinte.nuance), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.teinte.collection), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.teinte.structure), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.teinte.referenceDusage), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.teinte.referenceUtilisee), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}